import Button from './Button'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { AllowedButtonTags, ButtonProps } from './types'

const ClientButton = forwardRef(function ClientButton<T extends AllowedButtonTags = 'button'>(
  {
    onKeyDown: onKeyDown_,
    onKeyUp: onKeyUp_,
    onKeyDownCapture: onKeyDownCapture_,
    onKeyUpCapture: onKeyUpCapture_,
    onClick: onClick_,
    ...props
  }: ButtonProps<T>,
  ref: React.Ref<HTMLElement>
) {
  const { disabled: softDisableButton, busy } = props
  const disabled = softDisableButton || busy
  const onKeyDown = disabled ? preventDefault : onKeyDown_
  const onKeyUp = disabled ? preventDefault : onKeyUp_
  const onKeyUpCapture = disabled ? preventDefault : onKeyUpCapture_
  const onClick = disabled ? preventDefault : onClick_
  return (
    <Button
      // working around generics
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(props as any)}
      onClick={onClick}
      onChange={onKeyDown}
      onKeyUp={onKeyUp}
      onKeyUpCapture={onKeyUpCapture}
      ref={ref}
    />
  )
})

export default ClientButton
